import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import Shimmer from "../Shimmer/Shimmer";
import apiServiceHandler from "../../service/apiService"
import { updateCoursesDetails } from "../../redux/coursesData";
import { useDispatch, useSelector } from "react-redux";
import Logo from '../../assets/image.png'
import STG from '../../assets/STG90.png'
import PBA from '../../assets/PBA.png'
import BOA from '../../assets/BOA.png'
import CLUB84 from '../../assets/CLUB84.png'

const CoursesOverview = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [courseData, setCourseData] = useState([])
  const userDetails = JSON.parse(localStorage.getItem('userDetails')) || null;
  const course = useSelector((state) => state.coursesData.coursesDetails);

  const getCourses = async () => {
    try {
      setLoading(true);
      const response = await apiServiceHandler("GET", "api/courses");
      // console.log(response, 'response is here...')
      if (response.status) {
        setCourseData(response.data)
        dispatch(updateCoursesDetails(response.data));
      }
    } catch (error) {
      console.error(error.response);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCourses();
  }, []);

  return (
    <div className="courses-page-section">
      <div className="courses-page-section-header">
        <div className="courses-header">
          <div className="courses-header-top">
            <div className="courses-header-content">
              <div className="courses-header-heading">My Courses and Programs</div>
            </div>
          </div>
        </div>
      </div>
      <div className="courses-page-section-body">

        {loading ? (
          <Shimmer number={4} />
        ) : (courseData && courseData.length > 0 ? (
          courseData.map((course, index) => (
            <div className="overview-container" key={index}>
              <div className="courses-card">
                <div className="courses-card__wrapper">
                  <div className="courses-card__image">
                    {/* <img src="https://firebasestorage.googleapis.com/v0/b/jurni-prod.appspot.com/o/content%2FaBpSbfjD5quXt4RpthVC%2F1b88e8ac-0ff4-4431-8c72-3efcd5d18602?alt=media&token=d9b50a7c-a884-4da9-ac9a-8646b1299740" /> */}
                    <img src={course.course_code == 'stg90' ? STG : (course.course_code == 'pba') ? PBA : (course.course_code == 'boa') ? BOA : (course.course_code == 'club84') ? CLUB84 : Logo} />
                  </div>
                  <div className="courses-card__heading">
                    <span>{course.title}</span>
                  </div>
                  <div className="courses-card__content">
                    <div className="card-meta-item">
                      <div className="card-meta-item-icon"></div>
                      <div className="card-meta-item-content"></div>
                    </div>
                    <div className="steps-info">
                      <div className="icon-brand">
                        <span className="icon--members">
                          <svg
                            viewBox="0 0 20 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon__svg"
                            preserveAspectRatio="xMidYMid meet"
                            style={{ width: "20px", height: "20px", paddingTop: "5px" }}
                          >
                            <path
                              d="M10 0a3 3 0 100 6 3 3 0 000-6zM3.5 1a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm13 0a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM10 18a4.505 4.505 0 01-4.5-4.5V8.75C5.5 7.785 6.285 7 7.25 7h5.5c.965 0 1.75.785 1.75 1.75v4.75c0 2.481-2.019 4.5-4.5 4.5zm-5.5-4.5V8.75c0-.664.237-1.274.63-1.75H1.75C.785 7 0 7.785 0 8.75V12a4.005 4.005 0 005.03 3.865l.01-.004A5.459 5.459 0 014.5 13.5zm11 0V8.75c0-.664-.237-1.274-.63-1.75h3.38c.965 0 1.75.785 1.75 1.75V12a4.005 4.005 0 01-5.03 3.865l-.01-.004c.342-.716.54-1.516.54-2.361z"
                              fill="#000"
                            ></path>
                          </svg>
                        </span>
                      </div>
                      <div>{course.activeMembers} Members</div>
                    </div>
                    {/* <div className="card-meta-item">
                        <div className="card-meta-item-icon"></div>
                        <div className="card-meta-item-content"></div>
                      </div>
                      <div className="steps-info">
                        <div className="icon-brand">
                          <span className="icon--members">
                            <svg
                              viewBox="0 0 20 18"
                              fill="#000"
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon__svg"
                              preserveAspectRatio="xMidYMid meet"
                              style={{ width: "20px", height: "20px" }}
                            >
                              <path d="M6 7.5C4.07 7.5 2.5 5.93 2.5 4S4.07.5 6 .5 9.5 2.07 9.5 4 7.93 7.5 6 7.5zm0-5c-.827 0-1.5.673-1.5 1.5S5.173 5.5 6 5.5 7.5 4.827 7.5 4 6.827 2.5 6 2.5zm8-2a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM8.174 16.409A3.234 3.234 0 016 17.25 3.254 3.254 0 012.75 14v-3.75H8c0-.788.335-1.498.868-2H2.75c-1.103 0-2 .897-2 2V14A5.256 5.256 0 006 19.25a5.218 5.218 0 002.997-.945 5.961 5.961 0 01-.823-1.896zM17.25 8.5h-6.5C9.785 8.5 9 9.285 9 10.25V15c0 2.757 2.243 5 5 5s5-2.243 5-5v-4.75c0-.965-.785-1.75-1.75-1.75z"></path>
                            </svg>
                          </span>
                        </div>
                        <div>50 Active Groups</div>
                      </div> */}
                  </div>
                </div>
                <div className="courses-card__action" style={{ paddingRight: '10px' }}>
                  <Link to={`/courses/course/${index}/${course.title.toLowerCase().replace(/\s+/g, "-")}`}
                    state={{ course }} className="courses-card__btn">
                    <span>Visit</span>
                  </Link>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-courses-message">Currently you do not have access to any courses.</div>
        ))}

      </div>
    </div>
  );
};

export default CoursesOverview;
